<template>
  <div class="intro">
    <nav class="stepsnav">
      <span class="txt">
        <h4>Intro</h4>
        <h2 class="">Customize your product</h2>
      </span>
    </nav>

    <div class="intro-copy">
      <div class="wysiwyg">
        <h1>Configure Your SKU</h1>
        <p>
          LightArt uses your personalized SKU to help facilitated lead times and
          ensure all materials needed are available.
        </p>
      </div>

      <ul class="starting_sku">
        <li>
          <b>{{ product.family }}</b>
          <i>Family</i>
        </li>
        <li>
          <b>{{ product.model }}</b>
          <i>Model</i>
        </li>
        <li>
          <b>{{ product.type }}</b>
          <i>Type</i>
        </li>
      </ul>

      <span class="actions">
        <button class="next start-btn" @click="$emit('set-pointer-to-zero')">
          Start
        </button>
      </span>

      <div class="wysiwyg" v-html="outro"></div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    //
  },
  props: ["product", "intro", "outro"],
  computed: {
    //
  },
  methods: {
    //
  },
};
</script>
